import React, { useEffect, useState } from "react";
import { getApiData } from "../../services/index";
import "./index.css";
import GotQuestion from "./GotQuestion";
import Faq from "./FAQ";
import { Helmet } from "react-helmet";

const Accounting = () => {
  const [faqs, setFaqs] = useState([]);
  const [courses, setCourses] = useState([]);
  const [contentLoaded, setContentLoaded] = useState(false);
  const [metaTitle, setMetaTitle] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [metaDescription, setMetaDescription] = useState("");

  useEffect(() => {
    const checkData = async () => {
      const app = { slug: "Accounting" };
      const result = await getApiData("api/get_faq", app);
      if (result && result.status === 200) {
        const filteredFaqs = result.data.filter(
          (faq) => faq.slug === "Accounting"
        );
        setFaqs(filteredFaqs);
      }
    };
    checkData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getApiData("api/get_accounting", {});
      if (result && result.status === 200) {
        const filteredCourses = result.data.filter(
          (course) => course.slug === "Accounting"
        );
        setCourses(filteredCourses);
        setContentLoaded(true);

        if (filteredCourses.length > 0) {
          const selectedCourse = filteredCourses[0];

          // Ensure the meta tags are only set if the slug is correct
          if (selectedCourse.slug === "Accounting") {
            setMetaTitle(selectedCourse.meta_title);
            setMetaKeywords(selectedCourse.meta_keyword);
            setMetaDescription(selectedCourse.meta_description);
          }
        }
      }
    };
    fetchData();
  }, []);
  return (
    <>
      <Helmet>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />
        <meta name="keywords" content={metaKeywords} />
      </Helmet>
      {/* hero banner section */}
      {courses.length > 0 ? (
        courses.map((course, index) => (
          <section
            key={index}
            className="inner-banner relative min-h-[77vh] w-full overflow-hidden"
          >
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{
                backgroundImage: `url(${course.banner})`,
              }}
            ></div>
            <div className="absolute inset-0 bg-black opacity-50"></div>
            <div className="absolute inset-y-0 left-8 sm:left-8 lg:left-24 flex items-center">
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-semibold text-white mb-4 sm:mb-0">
                <span
                  className="block font-black text-5xl sm:text-6xl lg:text-7xl"
                  dangerouslySetInnerHTML={{ __html: course.banner_title }}
                />
              </h2>
            </div>
            <div className="absolute bottom-14 sm:bottom-7 lg:bottom-36 right-4 sm:right-8 px-4 w-full sm:w-4/5 md:w-3/5 lg:w-2/5 text-right">
              <p className="text-white subhead-main font-size-low">
                {course.banner_subtitle}
                <span className="desktop-break">
                  <br />
                </span>
                {course.banner_subtitle2}
              </p>
            </div>
          </section>
        ))
      ) : (
        <div className="text-center py-20 text-white">
          <p>Loading data...</p>
        </div>
      )}

      {/* Space between the sections*/}
      {contentLoaded && (
        <div className="block sm:hidden bg-[#070524] h-12"></div>
      )}

      {/* Photo with text section */}
      {courses.length > 0 &&
        courses.map((course, index) => (
          <section
            key={index}
            className="business-studies-about min-h-screen w-full bg-[#070524]"
          >
            <div className="container-fluid w-full">
              <div className="grid grid-cols-1 sm:grid-cols-2 min-h-screen gap-4 place-items-center">
                {/* Left Column - Dynamic Image */}
                <div className="w-full flex justify-center sm:justify-start sm:items-start">
                  <div className="business-studies-about__contents__wrapper-image w-full sm:w-3/4 md:w-2/3 h-full">
                    <img
                      className="w-full h-full object-cover"
                      src={course.section1_image}
                      alt="Construction Section"
                    />
                  </div>
                </div>

                {/* Right Column - Dynamic Text */}
                <div className="w-full flex justify-center sm:justify-start sm:items-start">
                  <div className="business-studies-about__contents__text text-white p-6 sm:p-12">
                    <p
                      className="subhead-main color-white"
                      dangerouslySetInnerHTML={{ __html: course.section1_desc }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        ))}

      {/* Entry Requirement sections */}
      {contentLoaded && (
        <section className="eligibility-requirements bg-gray-50 py-16">
          <div className="container mx-auto px-4">
            {/* Title */}
            <div className="text-center mb-16">
              <h2>
                <span className="text-primary">Entry</span> Requirements
              </h2>
            </div>

            {/* Content */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {/* Diploma of Accounting */}
              <div className="eligibility-card p-4 bg-white shadow-lg rounded-lg border border-gray-200">
                <h3 className="main-title mb-4">Diploma of Accounting</h3>
                <div className="eligibility-list space-y-4">
                  <div className="flex flex-col sm:flex-row items-start">
                    <p className="subhead-main w-full sm:w-1/3 mb-2 sm:mb-0">
                      Education:
                    </p>
                    <p className="subhead w-full sm:w-2/3">
                      Completion of Class 12th or equivalent.
                    </p>
                  </div>
                  <div className="flex flex-col sm:flex-row items-start">
                    <p className="subhead-main w-full sm:w-1/3 mb-2 sm:mb-0">
                      English Language:
                    </p>
                    <p className="subhead w-full sm:w-2/3">
                      IELTS 5.5 or equivalent.
                    </p>
                  </div>
                </div>
              </div>

              {/* Bachelor of Accounting */}
              <div className="eligibility-card p-4 bg-white shadow-lg rounded-lg border border-gray-200">
                <h3 className="main-title mb-4">Bachelor of Accounting</h3>
                <div className="eligibility-list space-y-4">
                  <div className="flex flex-col sm:flex-row items-start">
                    <p className="subhead-main w-full sm:w-1/3 mb-2 sm:mb-0">
                      Education:
                    </p>
                    <p className="subhead w-full sm:w-2/3">
                      Completion of Class 12th or equivalent.
                    </p>
                  </div>
                  <div className="flex flex-col sm:flex-row items-start">
                    <p className="subhead-main w-full sm:w-1/3 mb-2 sm:mb-0">
                      English Language:
                    </p>
                    <p className="subhead w-full sm:w-2/3">
                      IELTS 6.0 or equivalent.
                    </p>
                  </div>
                </div>
              </div>

              {/* Master of Accounting */}
              <div className="eligibility-card p-4 bg-white shadow-lg rounded-lg border border-gray-200">
                <h3 className="main-title mb-4">Master of Accounting</h3>
                <div className="eligibility-list space-y-4">
                  <div className="flex flex-col sm:flex-row items-start">
                    <p className="subhead-main w-full sm:w-1/3 mb-2 sm:mb-0">
                      Education:
                    </p>
                    <p className="subhead w-full sm:w-2/3">
                      An Australian undergraduate degree in a related field (or
                      equivalent).
                    </p>
                  </div>
                  <div className="flex flex-col sm:flex-row items-start">
                    <p className="subhead-main w-full sm:w-1/3 mb-2 sm:mb-0">
                      English Language:
                    </p>
                    <p className="subhead w-full sm:w-2/3">
                      IELTS 6.5 or equivalent.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* carrer pathway section */}
      <section className="career-pathways-single">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Left Column: Title */}
            <div className="col-span-1 md:col-span-1">
              <div>
                {courses.length > 0 && (
                  <h2>
                    <span
                      className="word"
                      data-word={courses[0].career_pathwaytitle}
                    >
                      <span className="word-wrap">
                        {courses[0].career_pathwaytitle}
                      </span>
                    </span>
                  </h2>
                )}
              </div>
            </div>

            {/* Right Column: Image and Content */}
            <div className="col-span-1 md:col-span-2">
              <div>
                <div className="career-pathways-single__contents__single__wrapper">
                  {courses.length > 0 && (
                    <>
                      <div>
                        <img
                          className="w-full h-[60vh] md:h-auto object-cover"
                          src={courses[0].career_pathwayimage}
                          alt="Career Pathways"
                        />
                      </div>
                      <h2>{courses[0].career_outcometitle}</h2>
                      <div className="carrer-desc">
                        <div className="pl-5">
                          {Array.isArray(courses[0].career_outcomedesc) ? (
                            courses[0].career_outcomedesc.map((item, index) => (
                              <div key={index} className="mb-8 border-gray-300">
                                <h3 className="font-semibold">
                                  {index + 1}: {item.title}
                                </h3>
                                <p
                                  className="subhead"
                                  dangerouslySetInnerHTML={{
                                    __html: item.description,
                                  }}
                                ></p>
                              </div>
                            ))
                          ) : (
                            <p
                              dangerouslySetInnerHTML={{
                                __html:
                                  courses[0].career_outcomedesc ||
                                  "No career outcomes available.",
                              }}
                            ></p>
                          )}
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      {contentLoaded && <Faq faqs={faqs} />}

      {/* got a question Section */}
      {contentLoaded && <GotQuestion />}
    </>
  );
};

export default Accounting;
